/**
 * <ReferralTermsCard> — « Voir les conditions » et ce qu'elles disent (organism).
 *
 * Les six règles du programme, mot pour mot celles du legacy. Le repli est de l'interface : il vit
 * ici. `onToggle` n'existe que pour l'effet de l'écran (le legacy compte l'ouverture) ;
 * `defaultExpanded` ouvre la story sans un clic.
 */
import { StyleSheet } from "react-native-unistyles"

import { Accordion } from "../../molecules/Accordion"
import { BulletList } from "../../molecules/BulletList"
import { Card } from "../../molecules/Card"
import { Icon } from "../../atoms/icons/Icon"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"

/** Les conditions du programme — la copie du legacy, inchangée. */
const TERMS = [
    "Cette offre est réservée aux nouveaux utilisateurs qui s'inscrivent via votre lien - nous voulons partager la magie Masteur et agrandir notre communauté !",
    "La récompense est accordée une fois que votre filleul active son abonnement. Aucune récompense ne sera accordée pour les inscriptions incomplètes.",
    "Chaque nouvel utilisateur ne peut générer qu'une seule récompense. Pas de cumul ni de contournement.",
    "Évitez de spammer ou d'utiliser votre lien de parrainage de manière abusive. Nos algorithmes surveillent l'engagement et nous alertent en cas d'activité suspecte.",
    "Si nous détectons une activité suspecte ou non conforme, nous nous réservons le droit de suspendre ou désactiver votre lien de parrainage.",
    "Nous pouvons modifier, suspendre ou mettre fin à ce programme à tout moment dans le cadre de notre amélioration continue.",
]

export type ReferralTermsCardProps = {
    /** Ouvre le repli au premier rendu — défaut fermé, comme le legacy. */
    defaultExpanded?: boolean
    /** Appelé à chaque bascule, avec l'état suivant. */
    onToggle?: (expanded: boolean) => void
    testID?: string
}

export function ReferralTermsCard(props: ReferralTermsCardProps) {
    const { defaultExpanded = false, onToggle, testID } = props

    return (
        <Accordion
            testID={testID}
            defaultExpanded={defaultExpanded}
            onToggle={onToggle}
            header={(expanded) => (
                <Row gap="2" justify="center" align="center" style={styles.header}>
                    <Text size="text-md" color="text-muted">
                        Voir les conditions
                    </Text>
                    <Icon name={expanded ? "chevron-up" : "chevron-down"} size={16} color="text-muted" />
                </Row>
            )}
        >
            <Card p="4" background="surface-subtle" style={styles.body}>
                <Stack gap="3">
                    <Text weight="bold">Conditions du programme de parrainage</Text>
                    <BulletList items={TERMS} />
                </Stack>
            </Card>
        </Accordion>
    )
}

const styles = StyleSheet.create((theme) => ({
    header: { paddingVertical: theme.spacing["2"] },
    body: { marginTop: theme.spacing["2"] },
}))
